import { BreadcrumbPathComponent } from 'src/components/BreadcrumbsTopnav/BreadcrumbsTopnav'
import { AppLocation } from 'src/navigation/appLocations'
import { reportingPinnedUrl, reportingUrl } from 'src/navigation/urls'

export const getGlobalBreadcrumbs = (
  appLocation: AppLocation,
  translate: (source: string) => string,
): BreadcrumbPathComponent[] | undefined =>
  appLocation === AppLocation.ReportingOverview
    ? [
        { path: translate('Reporting') },
        { path: translate('Overview'), url: reportingUrl() },
      ]
    : appLocation === AppLocation.ReportingPinned
      ? [
          { path: translate('Reporting') },
          { path: translate('Pinned'), url: reportingPinnedUrl() },
        ]
      : undefined
